import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import Content from '../../common/template/content';
import Tabs from '../../common/tab/tabs';
import TabsHeader from '../../common/tab/tabsHeader';
import TabsContent from '../../common/tab/tabsContent';
import TabHeader from '../../common/tab/tabHeader';
import TabContent from '../../common/tab/tabContent';
import PermissaoUsuario from '../../auth/permissao';
import { init, create, update } from './inventarioActions';

import List from './inventarioList';
import Form from './inventarioForm';
import Historico from './inventarioHistorico';
import TrocarForm from './inventarioTrocarForm';
import TipoList from './inventarioTipoList';
import CategoriaList from './inventarioCategoriaList';

class Inventario extends Component {
  componentWillMount() {
    this.props.init();
  }

  render() {
    return (
      <div>
        <Content>
          <Tabs>
            <TabsHeader>
              <TabHeader label="Listar" icon="bars" target="tabList" />
              <PermissaoUsuario tela="CadManutencaoInventario" campo="incluir" condicao={true}>
                <TabHeader label="Incluir" icon="plus" target="tabCreate" />
              </PermissaoUsuario>
              <PermissaoUsuario tela="CadManutencaoInventario" campo="alterar" condicao={true}>
                <TabHeader label="Alterar" icon="pencil-alt" target="tabUpdate" />
              </PermissaoUsuario>
              <PermissaoUsuario tela="CadManutencaoInventario" campo="historico" condicao={true}>
                <TabHeader label="Histórico" icon="history" target="tabHistorico" />
              </PermissaoUsuario>
              <PermissaoUsuario tela="CadManutencaoInventario" campo="alterar" condicao={true}>
                <TabHeader label="Trocar" icon="exchange-alt" target="tabTrocar" />
              </PermissaoUsuario>
              <PermissaoUsuario tela="CadManutencaoInventario" campo="tipos" condicao={true}>
                <TabHeader label="Tipos" icon="tags" target="tabTipos" />
              </PermissaoUsuario>
              <PermissaoUsuario tela="CadManutencaoInventario" campo="tipos" condicao={true}>
                <TabHeader label="Categorias" icon="layer-group" target="tabCategorias" />
              </PermissaoUsuario>
            </TabsHeader>
            <TabsContent>
              <TabContent id="tabList">
                <List />
              </TabContent>
              <TabContent id="tabCreate">
                <Form onSubmit={this.props.create} submitClass="primary" submitLabel="Salvar" premiumLayout />
              </TabContent>
              <TabContent id="tabUpdate">
                <Form onSubmit={this.props.update} submitClass="primary" submitLabel="Salvar" premiumLayout isUpdate />
              </TabContent>
              <TabContent id="tabHistorico">
                <Historico />
              </TabContent>
              <TabContent id="tabTrocar">
                <TrocarForm />
              </TabContent>
              <TabContent id="tabTipos">
                <TipoList />
              </TabContent>
              <TabContent id="tabCategorias">
                <CategoriaList />
              </TabContent>
            </TabsContent>
          </Tabs>
        </Content>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => bindActionCreators({ init, create, update }, dispatch);
export default connect(null, mapDispatchToProps)(Inventario);
